"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HOW_CAN_WE_HELP_IMAGE_URL = exports.CONTACT_US_PATH = void 0;
const HOW_CAN_WE_HELP_IMAGE_URL = exports.HOW_CAN_WE_HELP_IMAGE_URL = 'https://media-we-cdn.oriflame.com/contentImage?externalMediaId=a82b8587-9e33-41ee-9cd1-e6341f52e8b5&name=support-center&inputFormat=jpg';
const CONTACT_US_PATH = exports.CONTACT_US_PATH = '/support-center/company-information/local-information/how-can-i-contact-oriflame';
